import * as React from "react";
import {cs} from "../../../../../../../../common/react/chain-services";
import "./qty.scss";

export const Qty = ({value, xdQaName, sampleCard=false}) => cs(
    () => (
        <div className="qty qty-251" xd-qa-type="label" xd-qa-name={xdQaName}>
            Qty: {value + (sampleCard? 1: 0)}
        </div>
    ),
);
